import { createContext } from 'react';

// Historical hook: a workspace used to "borrow" a collapsed sidebar for its
// visit. Since Lane 1363 the company nav is ALWAYS the collapsed icon rail
// (it only widens as an overlay on hover), so there is nothing to borrow and
// AppLayout no longer provides this context. Callers get this no-op default.
export default createContext(() => undefined);
